<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  const { origin, search } = new URL(document.baseURI);
  const searchParams = new URLSearchParams(search);
  const next = searchParams.get("next");
  const successRoute = router.resolve({ name: RouteNames.LoginSuccess });

  const nextQuery = next && !next.includes(RouteNames.Logout) ? `?next=${next}` : "";
  const successUri =
    import.meta.env.BASE_URL !== "/"
      ? origin + router.options.history.base + nextQuery + successRoute.fullPath
      : origin + successRoute.fullPath + nextQuery;

  await authStore.login(successUri, route.query.register === "true");
});
</script>

<template>
  <FullPageCenteredLayout>
    <template #title>Connecting to your account…</template>

    <main class="login">
      <SkoreSpinner />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.login {
  text-align: center;
}
</style>
